import PrintBarcodes from "emun.products/lists/product-list-barcode";
import EmailPrompt from "emun.swatch/email-count-prompt";
import swatchConfig from "emun.swatch/swatch.config";
import templateUrl from "emun.swatch/swatchcount-header.htm";
import SwatchCountPrompt from "emun.swatch/swatchcount-prompt";
import basicController from "servicestack/basic.controller.properties";
import ServiceBus from "servicestack/service-bus";
import $session from "servicestack/session";

class SwatchCountHeaderController {
  constructor($window, $rootScope, NgMap, $timeout) {
    const $ctrl = this;
    basicController($ctrl);
    $ctrl.$session = $session;
    $ctrl.$window = $window;
    $ctrl.swatchConfig = swatchConfig;
    $ctrl.bus = new ServiceBus();
  }
  edit() {
    //        return this.prompt.edit(this.count).then(() => this.container.query.load(true));
    SwatchCountPrompt.open({ model: { count: this.count } }).then(() =>
      this.container.query.load(true)
    );
  }

  emailCount() {
    let $ctrl = this;
    if ($ctrl.count.countType.toUpperCase() == "STOCK") {
      EmailPrompt({ count: $ctrl.count });
    } else {
      var link =
        "mailto:" +
        ($ctrl.$session.meta.CustomerServiceEmail ||
          $ctrl.swatchConfig.customerServiceEmail) +
        "?";
      if ($ctrl.swatchConfig.customerServiceEmail2) {
        link = link + "&cc=" + $ctrl.swatchConfig.customerServiceEmail2;
      }
      link =
        link +
        "&subject=Swatch%20Count&body=" +
        $ctrl.$window.location.protocol +
        "//" +
        $ctrl.$window.location.hostname +
        $ctrl.swatchConfig.emailLink +
        this.count.id;
      $ctrl.$window.location = link;
    }
  }
  backToCounts() {
    const $ctrl = this;
    if ($ctrl.count.countType.toUpperCase() == "STOCK") {
      $ctrl.$state.transitionTo("swatch.stock-counts", {
        countType: $ctrl.count.countType,
      });
    } else {
      $ctrl.$state.transitionTo("swatch.counts", {
        countType: $ctrl.count.countType,
      });
    }
  }

  downloadAllData() {
    let $ctrl = this;
    var url;
    if ($ctrl.count.countType.toUpperCase() == "STOCK")
      url = $ctrl.$appConfig.resolveServiceUrl(
        "RunReport?reportName=QuickReport&displayName=" +
          $ctrl.count.countName +
          "&output=xlsx&QuickReportID=StockCountAll" +
          "&QuickReportName=StockCountAll" +
          "&@ListId=" +
          $ctrl.count.listId +
          "&@CountId=" +
          $ctrl.count.id
      );
    else
      url = $ctrl.$appConfig.resolveServiceUrl(
        "QuerySwatchCountExceptions.csv?CountId=" + $ctrl.count.id
      );

    if ($ctrl.swatchConfig.customSort) url = url + "&CustomSort=1";
    return (location.href = url);
  }
  downloadExceptionData() {
    let $ctrl = this;
    var url;
    if ($ctrl.count.countType.toUpperCase() == "STOCK")
      url = $ctrl.$appConfig.resolveServiceUrl(
        "RunReport?reportName=QuickReport&displayName=" +
          $ctrl.count.countName +
          "&output=xlsx&QuickReportID=StockCountExceptions" +
          "&QuickReportName=StockCountExceptions" +
          "&@ListId=" +
          $ctrl.count.listId +
          "&@CountId=" +
          $ctrl.count.id
      );
    else
      url = $ctrl.$appConfig.resolveServiceUrl(
        "QuerySwatchCountExceptions.csv?CountId=" + $ctrl.count.id
      );

    if ($ctrl.swatchConfig.customSort) url = url + "&CustomSort=1";
    return (location.href = url);
  }
  printBarcodes(list) {
    const $ctrl = this;
    return PrintBarcodes({
      ...this,
      request: {
        countId: $ctrl.count.id,
      },
    });
  }
}

const SwatchCountHeader = {
  bindings: {
    count: "<",
  },
  require: {
    container: "^swatchcountEdit",
  },
  controller: SwatchCountHeaderController,
  templateUrl($element, $attrs) {
    return $attrs.templateUrl || templateUrl;
  },
};

export default SwatchCountHeader;
